export default "__VITE_ASSET__qJlHaqoC__"